import { RefreshCw } from "lucide-react";

import useAtualizacaoDisponivel from "./useAtualizacaoDisponivel";

/** Faixa fixa no topo quando o site foi atualizado e esta aba ainda roda o
 *  bundle antigo. Um clique recarrega; quem ficou 10 min fora recarrega
 *  sozinho ao voltar (ver o hook). */
export default function BannerAtualizacao() {
  const { disponivel, versao, atualizar } = useAtualizacaoDisponivel();
  if (!disponivel) return null;
  return (
    <div data-e2e="banner-atualizacao" className="sticky top-0 z-[70] flex items-center justify-center gap-3 bg-primary text-primary-foreground px-4 py-2 text-sm shadow-md">
      <RefreshCw className="w-4 h-4 shrink-0" />
      <span>
        <strong>Nova versão do Núcleo disponível{versao ? ` (v${versao})` : ""}.</strong>{" "}
        <span className="hidden sm:inline">Atualize para ver as novidades e evitar erros.</span>
      </span>
      <button type="button" onClick={atualizar}
        className="ml-1 rounded-md bg-primary-foreground text-primary font-semibold px-3 py-1 hover:opacity-90 transition-opacity">
        Atualizar agora
      </button>
    </div>
  );
}
